import React, {useState, useEffect} from 'react';
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import { MasterDataGrid } from "@/components/";
import { Utilities, Enums } from "@utils";
import OverlapDetail from './overlap-detail';
import styles from './index.module.scss';
import dxDataGrid from 'devextreme/ui/data_grid';
import { ColumnSections } from '@/utils/constants';

export interface IByOverlapsProps{    
    dataColumns: any;
	currentYear: string;
	stepData: any;
	status: any;
	screen: any;
	columns: any;
	overData: any;
	refresh: any;
	tableAlert: string;
	saveTable(instance: any): void;
}

const BeneficiariesOverlaps: React.FC<any> = ({dataColumns, columns, screen, tableAlert, overData, status, refresh, saveTable}: IByOverlapsProps) =>{
	const [auxCol, setAuxCol] = useState<any>(null);
	const [auxData, setAuxData] = useState(null);
	const [errorDetail, setErrorDetail] = useState(false);

	const view: IFollowupSubproject = {
        state: {
			dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

	useEffect(() => {
        if(presenter.resultsFramework && presenter.beneficiariesData) {
            let overlap = getAuxColumns()
			setAuxCol(overlap)
        }
    }, [columns?.overlap, presenter.resultsFramework, presenter.beneficiariesData]);  

	

    const renderDetail = (data:any)=>{ 
		return (
			<OverlapDetail
				tableAlert={tableAlert} 
				saveTable={saveTable} 
				status={status}
				presenter={presenter} 
				auxCol={auxCol} 
				data={data} 
				screen={screen}
				isTourSeen={presenter.tourBenSeen}
			></OverlapDetail>
		)
    }

	const getAuxColumns = () => {
		let colParent = Utilities.copyObject(columns?.overlap)
		let colOver = Utilities.copyObject(columns?.overlap)
		colOver = colOver.filter((col: any) => {
			if(![Enums.FollowupBasicFields.achievedBeneficiaries, Enums.FollowupBasicFields.accumBeneficiaries, Enums.FollowupBasicFields.activityPercentage].includes(col.dataField)){
				if(col.dataField === Enums.FollowupBasicFields.totalMonthPl){
					col.calculateCellValue = (data: any) => presenter.calTotalMonthPl(data)
				}
				if(col.dataField !== Enums.FollowupBasicFields.result && col.dataField !== Enums.FollowupBasicFields.beneficiariesByResult){
					if(col?.columns?.length){
						for (const childCol of col.columns) {
							childCol.width = 120
						}
					}
					col.width = 120
				}
				return col
			}
		})
		
		colParent = colParent.filter((col: any) => {
			if(col.dataField !== Enums.FollowupBasicFields.result && col.dataField !== Enums.FollowupBasicFields.beneficiariesByActivity){
				if(col?.columns?.length){
					for (const childCol of col.columns) {
						childCol.allowEditing = false
						childCol.width = 120
					}
				}
				col.width = 120
			}
			col.allowEditing = false
			return col
		})

		if(status?.CodigoDimension === Enums.FollowupState.planning) colParent.push({caption: "", id: "test", allowEditing: false})
		return {colParent, colOver};
	}

	useEffect(() => {
		if(tableAlert === 'All') presenter.getTableInstance('beneficiaries-by-overlap').collapseAll(-1)
        if((!tableAlert || tableAlert === 'All' || tableAlert?.includes("beneficiaries-by-overlap-detail")) && overData?.data && auxCol?.colParent?.length && ((presenter.stepTourBen <= 4 && !presenter.tourBenSeen) || presenter.tourBenSeen)) {
			if(presenter.stepTourBen >= 4){
                let dataTour = presenter.getTourData(8, Enums.FollowupDimensions.beneficiaries)
                let asd = getAuxData(dataTour)
                setAuxData(asd)
            }else{
                let asd = getAuxData()
                setAuxData(asd)
            }
        }
    }, [overData?.data, tableAlert, auxCol?.colParent, refresh, presenter.stepTourBen]); 

	const onRefChange = (ref: any) => {
		const grid: dxDataGrid = ref.current.instance;
		const element = grid.element()
		element.setAttribute('style','display:flex;overflow-x:auto')
	}

	useEffect(() => {
        if(tableAlert === 'All') {
			let error = false
			for (const table of overData.data) {
				let overlap = table?.overlaps
				for (const item of overlap) {
					if(!error) error = !presenter.checkReqFields(item, status)
					if(!error) error = !presenter.checkBenPlan(item, status.CodigoDimension)
				}
			}
			setErrorDetail(error)
        }else setErrorDetail(false)
    }, [tableAlert]); 

	const getAuxData = (tourData?: any) => {
		return (
            <div>
                <MasterDataGrid 
					onRefChange={onRefChange}
					id={`beneficiaries-by-overlap`}
					dataSource={tourData || overData.data}
					columns={auxCol?.colParent}
					allowCode={screen}
					gridTitle={presenter.followupLabels.get("beneficiariesByOverlapTitle")}
					gridHelpId={'tooltip-byoverlap'}
					gridHelpText={presenter.followupLabels.get("helpBeneficiariesByOverlap")}
					saveTable={saveTable}
					gridProps={{
						scrolling: { mode: "standard", useNative: true, showScrollbar: 'never'},
						className: (presenter.stepTourBen >= 4) ? styles.tableHeightTour : null,
						editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
						rowAlternationEnabled:false,
					}}
					expandAll={presenter.stepTourBen >= 4}
					idTitle={'BeneficiariesTourStep7'}
					render = {renderDetail}  
				/>
            </div>
        )
    }

	return (
		<div className={styles.divPpal}>
			<div style={{width:"100%", textAlign:"center"}}>
                <h6 style={{color:"red", padding:"1rem 1rem 0"}}>{errorDetail ? presenter.followupLabels.get("errorOverlap") : ''}</h6>
            </div>
			{auxData && auxData}
		</div>
	)
}

export default BeneficiariesOverlaps;